(function () {

  const CARD_SELECTOR = ".t4s-product, .product-card, .prd, [data-product-card], [data-zapiet-card]";
  const PREDICTIVE_ITEM_SELECTOR = ".t4s-search-fullwidth__item, .t4s-mini-search__content .t4s-product, [data-results-search] .t4s-product";
  const SECTIONS_TO_OBSERVE = [
    ".id_recently_viewed",
    ".id_product-recommendations",
    ".product-recommendations",
    "#product-recommendations",
    "[data-section-type='product-recommendations']",
    ".t4s-mini-search__content",
    "[data-results-search]",
    ".predictive-search",
    ".search-results"
  ];

  const PAGE_PATH = window.location.pathname;
  const IS_RESTRICTED_PAGE = ['/cart', '/checkout', '/checkouts', '/thank_you'].some(
    p => PAGE_PATH.includes(p)
  );
  if (IS_RESTRICTED_PAGE) return;

  const CARD_STATE_CACHE = new WeakMap();
  let zapietLock = false;
  function lockZapietUpdates(temp = false, ms = 800) {
    zapietLock = true;
    if (temp) setTimeout(() => { zapietLock = false; }, ms);
  }

  function injectBadgeStyles() {
    if (document.getElementById("zapiet-card-badges")) return;
    const style = document.createElement("style");
    style.id = "zapiet-card-badges";
    style.innerHTML = `
      ${CARD_SELECTOR} { position: relative; isolation: isolate; }
      .zapiet-badge { font-weight:500; padding:4px 6px; font-size:11px; position:absolute; top:8px; left:12px; border-radius:6px; z-index:10; pointer-events:none; color:#fff; min-width:64px; text-align:center; line-height:1; box-shadow:0 2px 6px rgba(0,0,0,.18); }
      .zapiet-disabled { opacity:.38; pointer-events:none; }
      .badge-available { background: rgba(0,207,131,.97); }
      .badge-sold-out { background: rgba(128,128,128,.92); }
      .badge-partially-available { background: rgba(255,193,7,.92); color:#111; }
      .badge-unavailable { background: rgba(128,128,128,.92); }
      .badge-not-in-menu { background: rgba(100,100,100,.92); }
      .badge-loading { background: rgba(120,120,120,.5); color:#fff; }
      .no-click { pointer-events: none !important; cursor: default !important; }
    `;
    document.head.appendChild(style);
  }

  function isPredictiveCard(card) {
    if (!card || card.nodeType !== 1) return false;
    return !!(
      card.closest('.t4s-mini-search__content') ||
      card.closest('[data-results-search]') ||
      card.classList.contains("t4s-search-fullwidth__item")
    );
  }

  function ensureBadge(card) {
    if (!card || card.nodeType !== 1) return null;
    let badge = card.querySelector(".zapiet-badge");
    if (!badge) {
      badge = document.createElement("div");
      badge.className = "zapiet-badge badge-loading";
      badge.textContent = "…";
      try { card.prepend(badge); } catch (e) { card.insertBefore(badge, card.firstChild); }
    }
    return badge;
  }

  function setBadge(card, text, cls) {
    if (!card || card.nodeType !== 1) return;
    if (zapietLock && cls !== "badge-loading") return;
    const badge = ensureBadge(card);
    if (!badge) return;
    badge.textContent = text;
    badge.className = "zapiet-badge " + (cls || "badge-loading");
  }

  function paintLoadingBadges(scope = document) {
    const cards = scope.querySelectorAll ? scope.querySelectorAll(CARD_SELECTOR) : [];
    cards.forEach(c => ensureBadge(c));
  }

  function disableProduct(card, label) {
    if (isPredictiveCard(card)) return;
    card.classList.add("zapiet-disabled");
    const btn = card.querySelector("form[action*='/cart'] button[type='submit']");
    if (btn) {
      if (!btn.hasAttribute("data-original-label"))
        btn.setAttribute("data-original-label", btn.innerText.trim());
      btn.disabled = true;
      btn.innerText = label;
      btn.setAttribute("aria-disabled", "true");
    }
    const link = card.querySelector("a");
    if (link) {
      link.classList.add("no-click");
      link.style.pointerEvents = "none";
      link.style.cursor = "default";
      link.setAttribute("tabindex", "-1");
      link.setAttribute("aria-hidden", "true");
    }
  }

  function enableProduct(card) {
    card.classList.remove("zapiet-disabled");
    const btn = card.querySelector("form[action*='/cart'] button[type='submit']");
    if (btn) {
      const original = btn.getAttribute("data-original-label") || "Add to Cart";
      btn.disabled = false;
      btn.innerText = original;
      btn.removeAttribute("aria-disabled");
    }
    const link = card.querySelector("a");
    if (link) {
      link.classList.remove("no-click");
      link.style.pointerEvents = "";
      link.style.cursor = "";
      link.removeAttribute("tabindex");
      link.removeAttribute("aria-hidden");
    }
  }

  function zapietState() {
    return {
      r: window.ZapietEats?.getSelectedRestaurant?.(),
      m: window.ZapietEats?.getSelectedMenu?.(),
      dRaw: window.ZapietEats?.getSelectedDate?.(),
      vm: window.ZapietWidgetConfig?.variant_metafields
    };
  }

  function isVariantSoldOut(vm, rest, menu, date, vid) {
    const vData = vm?.[vid];
    if (!vData) return false;
    const key = Object.keys(vData).find(
      k => k.includes(String(rest)) && k.includes(String(menu)) && k.includes(date)
    );
    const inv = key ? vData[key] : undefined;
    const toggledOff = inv?.toggled_off === true;
    const qtyZero = typeof inv?.remaining === "number" ? inv.remaining <= 0 : false;
    return toggledOff || qtyZero;
  }

function isVariantRestricted(restrictions, vid, dateIso, schedule) {
  // restrictions: array from menu (product_date_restrictions)
  // vid: variant id string
  // dateIso: "YYYY-MM-DD"
  // schedule: menu.config.schedule (optional)

  if (!Array.isArray(restrictions)) {
    // no explicit restrictions present
    // still allow schedule fallback below, so return false here (we'll check schedule separately)
    // but for this function we return false if no restrictions array is provided
    return false;
  }

  // helper to check schedule.specific_days key
  function scheduleSaysRestricted(dateToCheck) {
    if (!schedule || !schedule.specific_days) return false;
    const zapKey = (function(d){
      const dt = new Date(d);
      if (isNaN(dt)) return null;
      const month = dt.toLocaleString('en-US',{month:'short'}).toUpperCase();
      const day = String(dt.getDate()).padStart(2,'0');
      const year = dt.getFullYear();
      return `${month}-${day}-${year}`;
    })(dateToCheck);
    return zapKey && !!schedule.specific_days[zapKey];
  }

  // core check for one date string
  function checkDateAgainstRule(rule, checkDate) {
    if (String(rule.variant_id) !== String(vid)) return false;
    if (!rule.restriction_type || rule.restriction_type.toLowerCase() !== "deny") return false;

    // 1) exact restricted_dates array
    if (Array.isArray(rule.restricted_dates) && rule.restricted_dates.includes(checkDate)) return true;

    // 2) start_date / end_date range support
    if (rule.start_date && rule.end_date) {
      if (checkDate >= rule.start_date && checkDate <= rule.end_date) return true;
    }

    return false;
  }

  // 1) First try exact date match (preferred, authoritative)
  const exactMatch = restrictions.some(r => checkDateAgainstRule(r, dateIso));
  if (exactMatch) return true;

  // 2) If no exact match, try schedule.specific_days if available (authoritative fallback)
  if (scheduleSaysRestricted(dateIso)) return true;

  // 3) As a safe fallback (to handle Zapiet day-shift/lead-time quirks),
  //    check the day-before and day-after against rules and schedule.
  //    We prefer NOT to do this, but it's a pragmatic fix for Zapiet inconsistencies.
  const dt = new Date(dateIso);
  if (!isNaN(dt)) {
    const dayBefore = new Date(dt); dayBefore.setDate(dt.getDate() - 1);
    const dayAfter  = new Date(dt); dayAfter.setDate(dt.getDate() + 1);
    const isoBefore = dayBefore.toISOString().split("T")[0];
    const isoAfter  = dayAfter.toISOString().split("T")[0];

    // check rules for day-1 or day+1
    const beforeMatch = restrictions.some(r => checkDateAgainstRule(r, isoBefore));
    const afterMatch  = restrictions.some(r => checkDateAgainstRule(r, isoAfter));
    if (beforeMatch || afterMatch) return true;

    // also check schedule for day-1/day+1
    if (scheduleSaysRestricted(isoBefore) || scheduleSaysRestricted(isoAfter)) return true;
  }

  // nothing matched
  return false;
}


  function parseVariantIds(card) {
    let ids = [];
    let single = null;
    let shopifyAvailable = true;

    try {
      const inline = card.getAttribute("data-variant-ids");
      if (inline) ids = JSON.parse(inline.replace(/'/g, '"')).map(String);

      if (!ids.length) {
        const optsStr = card.getAttribute("data-product-options");
        if (optsStr) {
          const opts = JSON.parse(optsStr);
          if (opts?.VariantFirstID) single = String(opts.VariantFirstID);
          if (typeof opts?.available !== "undefined") shopifyAvailable = !!opts.available;
          if (Array.isArray(opts?.variants)) ids = opts.variants.map(v => String(v.id));
        }
      }
    } catch (e) {}

    return { ids: ids.length ? ids : (single ? [single] : []), shopifyAvailable };
  }

  function applyCardStateIfChanged(card, status, cls, disabledFlag) {
    const newState = `${status}|${cls}|${disabledFlag ? 1 : 0}`;
    const old = CARD_STATE_CACHE.get(card);
    if (newState === old) return;
    CARD_STATE_CACHE.set(card, newState);
    queueMicrotask(() => {
      setBadge(card, status, cls);
      if (disabledFlag)
        disableProduct(card, status === "SOLD OUT TODAY" ? "SOLD OUT TODAY" : "UNAVAILABLE");
      else enableProduct(card);
    });
  }

  function evaluateCard(card, vm, restrictions, rest, menu, date, menuSet) {
    if (!card || isPredictiveCard(card)) return;

    const { ids, shopifyAvailable } = parseVariantIds(card);
    if (!ids.length || !shopifyAvailable) {
      applyCardStateIfChanged(card, "UNAVAILABLE", "badge-unavailable", true);
      return;
    }

    const allNotInMenu = ids.every(id => !menuSet.has(String(id)));
    if (allNotInMenu) {
      applyCardStateIfChanged(card, "NOT IN MENU", "badge-not-in-menu", true);
      return;
    }

    const sold = ids.map(id => isVariantSoldOut(vm, rest, menu, date, id));
    const restr = ids.map(id => isVariantRestricted(restrictions, id, date));

    const allSold = sold.every(Boolean);
    const allRestr = restr.every(Boolean);
    const anyAvail = ids.some((_, i) => !sold[i] && !restr[i]);
    const anyLimited = sold.some(Boolean) || restr.some(Boolean);

    let status = "IN STOCK", cls = "badge-available";
    const allBad = ids.every((_, i) => sold[i] || restr[i]);

    if (allBad) {
      status = allSold ? "SOLD OUT TODAY" : "UNAVAILABLE";
      cls = allSold ? "badge-sold-out" : "badge-unavailable";
    } else if (anyLimited && anyAvail) {
      status = "LIMITED";
      cls = "badge-partially-available";
    }

    const disabledFlag = status !== "IN STOCK" && status !== "LIMITED";
    applyCardStateIfChanged(card, status, cls, disabledFlag);
  }

  function evaluateAllCards(scope = document) {
    const cards = scope.querySelectorAll(CARD_SELECTOR);
    if (!cards.length) return;

    const { r, m, dRaw, vm } = zapietState();
    if (!r || !m || !dRaw || !vm) {
      lockZapietUpdates(true, 1800);
      paintLoadingBadges(scope);
      setTimeout(() => waitForZapietEats(() => evaluateAllCards(scope)), 3000);
      return;
    }

    if (zapietLock) return;

    const selectedDate = new Date(dRaw).toISOString().split("T")[0];

    const deliveryOption = window.ZapietEats.getDeliveryOption?.() === "pickup"
      ? "store_pickup"
      : "local_delivery";

    const restrictions = m?.config?.[deliveryOption]?.product_date_restrictions || [];

    const menuIds = [];
    m?.menu_sections?.forEach(section => {
      section?.menu_section_items?.forEach(item => {
        if (item?.product?.variant_id)
          menuIds.push(String(item.product.variant_id));
      });
    });

    const menuSet = new Set(menuIds);

    cards.forEach(card =>
      evaluateCard(card, vm, restrictions, r.id, m.id, selectedDate, menuSet)
    );
  }

  function waitForZapietEats(cb, tries = 0) {
    if (window.ZapietEats?.getSelectedMenu && window.ZapietWidgetConfig?.variant_metafields) {
      cb();
    } else if (tries < 80) {
      setTimeout(() => waitForZapietEats(cb, tries + 1), 250);
    } else {
      evaluateAllCards();
    }
  }

  let rafToken = null;
  let debounceLock = false;

  function scheduleEvaluate() {
    if (debounceLock) return;
    debounceLock = true;
    if (rafToken) cancelAnimationFrame(rafToken);
    rafToken = requestAnimationFrame(() => {
      debounceLock = false;
      evaluateAllCards();
    });
  }

  function addObservers() {
    document.addEventListener("zapieteats:ready", scheduleEvaluate);
    document.addEventListener("zapieteats:change", scheduleEvaluate);
    document.addEventListener("zapieteats:refresh", scheduleEvaluate);

    setInterval(() => {
      const hour = new Date().getHours();
      if (hour === 0 || hour === 7) scheduleEvaluate();
    }, 1800000);

    const observed = new WeakSet();
    function attach(container) {
      if (observed.has(container)) return;
      const o = new MutationObserver(() => scheduleEvaluate());
      o.observe(container, { childList: true, subtree: true });
      observed.add(container);
    }

    function attachToExisting() {
      SECTIONS_TO_OBSERVE.forEach(sel => {
        document.querySelectorAll(sel).forEach(c => attach(c));
      });
      attach(document.body);
    }

    attachToExisting();

    let scans = 0;
    const scanner = setInterval(() => {
      attachToExisting();
      scheduleEvaluate();
      scans++;
      if (scans >= 8) clearInterval(scanner);
    }, 2500);
  }

  function predictiveBadgeHtmlFromStatus(status) {
    if (!status) return '';
    const s = String(status).toUpperCase();
    switch (s) {
      case 'UNAVAILABLE': return `<span class="zapiet-badge badge-unavailable">Unavailable</span>`;
      case 'AVAILABLE': return `<span class="zapiet-badge badge-available">Available</span>`;
      case 'DATE_RESTRICTED': return `<span class="zapiet-badge badge-partially-available">Ready Tomorrow</span>`;
      case 'LIMITED': return `<span class="zapiet-badge badge-partially-available">Limited</span>`;
      case 'SOLD_OUT': return `<span class="zapiet-badge badge-sold-out">Sold Out</span>`;
      default: return '';
    }
  }

  function applyPredictiveBadges(scope = document) {
    const items = scope.querySelectorAll(PREDICTIVE_ITEM_SELECTOR);
    if (!items.length) return;

    items.forEach(item => {
      const card = item.classList.contains("t4s-search-fullwidth__item")
        ? item
        : (item.querySelector(".t4s-search-fullwidth__item") || item);

      if (!card) return;

      let box = card.querySelector('.t4s-products-availability-badge');
      if (!box) {
        box = document.createElement('div');
        box.className = 't4s-products-availability-badge';
        card.prepend(box);
      }

      const json = card.querySelector('script[type="application/json"]');
      let data = null;

      if (json) {
        try { data = JSON.parse(json.textContent.trim()); } catch (e) {}
      } else {
        const a = card.getAttribute('data-zapiet-availability') || card.getAttribute('data-availability');
        if (a) data = { zapietAvailability: a };
      }

      const avail = data?.zapietAvailability || data?.availability || card.getAttribute('data-zapiet-availability');
      const html = predictiveBadgeHtmlFromStatus(avail);

      box.innerHTML = html || "";
    });
  }

  function observePredictive() {
    applyPredictiveBadges();

    const observer = new MutationObserver(mutations => {
      let touched = false;
      mutations.forEach(m => {
        m.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;
          if (node.matches?.(PREDICTIVE_ITEM_SELECTOR)) touched = true;
          if (node.querySelector?.(PREDICTIVE_ITEM_SELECTOR)) touched = true;
        });
      });
      if (touched) applyPredictiveBadges();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    injectBadgeStyles();
    paintLoadingBadges(document);
    waitForZapietEats(() => {
      evaluateAllCards();
      addObservers();
      observePredictive();
      setTimeout(() => { evaluateAllCards(); applyPredictiveBadges(); }, 1400);
      setTimeout(() => { evaluateAllCards(); applyPredictiveBadges(); }, 3200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
